import React from 'react';
import { connect } from 'react-redux';

import EditableLabel from 'APP_ROOT/components/EditableLabel';
import geofences from 'APP_ROOT/data/geofences';

const BUTTON_VISIBILITY_ON_MAP_CLASS_NAME = "resource-visibility-on-map";
export class Geofence extends React.PureComponent {

    startEditing = () => {
        this.props.setEditingItemName(this.props.geofenceId, true);
    }

    stopEditing = () => {
        this.props.setEditingItemName(this.props.geofenceId, false);
    }

    changeName = (newName) => {
        this.props.setGeofenceName(newName);
        this.props.setEditingItemName(this.props.geofenceId, false);
    }

    selectItem = (geofenceId, visible) => {
        this.props.onSelectResource('geofence', geofenceId, visible);
    }

    render() {

        const {
            geofenceId,
            name,
            selected,
            editingName,
            nameChangePending,
            visible,
            setVisible,
            geofenceType
        } = this.props;

        const resourceClasses = ["resource"];
        if (selected) resourceClasses.push("selected");

        return (
            <li className={resourceClasses.join(" ")} onClick={ (event) => {
                const parentNode = event.target.parentNode;
                if (parentNode.className &&
                    parentNode.className instanceof String && // "className" can be seemingly unrelated objects for SVG elements
                    parentNode.className.includes(BUTTON_VISIBILITY_ON_MAP_CLASS_NAME)) {
                    this.selectItem(geofenceId, !visible); // visibility is being toggled on this click
                    return;
                }
                this.selectItem(geofenceId, visible);
            }}>
                <header className="resource-header">
                    <h3 className="resource-name">
                        <EditableLabel
                            value={name}
                            editing={editingName}
                            loading={nameChangePending}
                            onRequestEdit={this.startEditing}
                            onChange={this.changeName}
                            onCancel={this.stopEditing}
                            maxLength={geofences.GEOFENCE_NAME_MAX_LENGTH}
                        />
                    </h3>
                </header>
                <button className={BUTTON_VISIBILITY_ON_MAP_CLASS_NAME} onClick={() => setVisible(geofenceId, !visible)}>
                    {!visible ?
                        <i className="material-icons unchecked">check_box_outline_blank</i> :
                        <i className="material-icons checked">check_box</i>
                    }
                </button>
                <span className="status-icons">
                    <div className="goefence">
                        {geofenceType === 'Polygon' ?
                            <div className={"proportionate-polygon " + this.props.proportionateSize} style={{'--geofence-bgcolor': this.props.color}}><div className={this.props.proportionateSize}></div></div> // https://stackoverflow.com/a/68721147 | use pseudo elements in reactjs as inline styling
                            :
                            <div className={"proportionate-circle " + this.props.proportionateSize} style={{
                            background: this.props.color
                            }}></div>
                        }
                    </div>
                </span>

            </li>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        name: geofences.Selectors.geofenceName(state, ownProps.geofenceId),
        nameChangePending: geofences.Selectors.geofenceNameChangePending(state, ownProps.geofenceId),
        visible: geofences.Selectors.isGeofenceVisible(state, ownProps.geofenceId),
        color: geofences.Selectors.geofenceColor(state, ownProps.geofenceId),
        colorChangePending: geofences.Selectors.geofenceStyleChangePending(state, ownProps.geofenceId) ? 'PENDING' : '',
        proportionateSize: geofences.Selectors.geofenceProportionateSize(state, ownProps.geofenceId),
        geofenceType: geofences.Selectors.geofenceType(state, ownProps.geofenceId),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setGeofenceName: name => dispatch(geofences.Actions.setGeofenceName(ownProps.stage, ownProps.geofenceId, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Geofence);
